import { createFileRoute } from "@tanstack/react-router";
import { Radio } from "lucide-react";
import { useMatchHub } from "@/hooks/useMatchHub";
import { MATCHES } from "@/lib/matches";
import { MediaBlitzHub } from "@/components/media/MediaBlitzHub";
import { CountdownPulse } from "@/components/countdown/CountdownPulse";
import { useDemoCountdownPhase } from "@/lib/countdown/worldCupCountdown";
import { WorldCupTagline } from "@/components/brand/WorldCupTagline";
import { BrandSlogan } from "@/components/brand/BrandSlogan";

export const Route = createFileRoute("/media-blitz")({
  head: () => ({
    meta: [
      { title: "Media Blitz — VerseSport World Cup" },
      { name: "description", content: "Hub viral del Mundial: clips, formatos, agenda de momentos y media kit para sponsors." },
      { property: "og:title", content: "Media Blitz — VerseSport World Cup" },
      { property: "og:description", content: "Distribuye VerseSport en TikTok, Reels, Shorts, X, WhatsApp y más." },
      { property: "og:url", content: "https://versesport.com/media-blitz" },
    ],
    links: [{ rel: "canonical", href: "https://versesport.com/media-blitz" }],
  }),
  component: MediaBlitzPage,
});

function MediaBlitzPage() {
  const phase = useDemoCountdownPhase();
  const hub = useMatchHub(0, { enabled: false });
  const activeMatch = MATCHES.find((m) => m.id === hub.activeId) ?? MATCHES[0];
  const snap = hub.snapshots[activeMatch.id];
  return (
    <main className="mx-auto max-w-3xl space-y-5 px-4 py-6">
      <header className="flex items-center gap-2">
        <Radio className="h-6 w-6 text-primary" />
        <h1 className="text-2xl font-black tracking-tight">Media Blitz</h1>
        <div className="ml-auto"><CountdownPulse phase={phase} /></div>
      </header>
      {activeMatch && (
        <div className="rounded-xl border border-primary/30 bg-primary/5 p-2.5 text-[11px] font-bold">
          🎯 Partido activo:{" "}
          <span className="text-primary">
            {activeMatch.homeFlag} {activeMatch.homeCode} vs {activeMatch.awayCode} {activeMatch.awayFlag}
          </span>
          <span className="ml-2 text-muted-foreground">· Min {snap?.minute ?? "—"}</span>
        </div>
      )}
      <p className="text-sm text-muted-foreground">
        Centro viral del Mundial: genera clips listos para TikTok, Reels, Shorts, X, WhatsApp y Discord — y mide el impacto en vivo.
      </p>
      <BrandSlogan section="splash" size="xs" align="left" />
      <WorldCupTagline size="xs" align="left" withProduct />
      <MediaBlitzHub />
    </main>
  );
}